import { makeStyles, TableCell, TableSortLabel } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LISTS_COMMON_STYLES } from 'style/lists';
import { OrderDirection } from 'types';
import { EntityColumn } from './TableCellWithConfigurableStyle';

const useStyles = makeStyles(LISTS_COMMON_STYLES);
interface TableCellHeaderWithConfigurableStyleProps {
  column: EntityColumn;
  createSortHandler: (property: string) => (event: React.MouseEvent<unknown>) => void;
  orderBy: string | null;
  order: OrderDirection;
}

const TableCellHeaderWithConfigurableStyle: React.FC<TableCellHeaderWithConfigurableStyleProps> = ({
  column,
  createSortHandler,
  orderBy,
  order,
}) => {
  const classes = useStyles(column.style);
  const { t } = useTranslation();

  return (
    <TableCell
      className={classNames(classes.cell, {
        [classes.centeredCell]: column.type && ['bool', 'hour', 'number'].includes(column.type),
        [classes.rightAlignedCell]: column.type && ['quantity', 'weightKg'].includes(column.type),
      })}
    >
      {column.disableSort || !column.columnPath ? (
        t(column.headerTranslationKey)
      ) : (
        <TableSortLabel
          active={orderBy === column.columnPath}
          direction={orderBy === column.columnPath ? order : 'asc'}
          onClick={createSortHandler(column.columnPath)}
          disabled={!column.columnPath || column.disableSort}
        >
          {t(column.headerTranslationKey)}
        </TableSortLabel>
      )}
    </TableCell>
  );
};

export default TableCellHeaderWithConfigurableStyle;
